import React from 'react';
import { Link } from 'react-router-dom';
import {
  ArrowLeft,
  ArrowRight,
  Bell,
  FileCheck,
  Receipt,
  Truck,
  Users,
  Wallet,
  BarChart3,
} from 'lucide-react';
import { useLanguage } from '../i18n/LanguageContext';
import ShowcaseScroll from '../components/ShowcaseScroll';

const featureIcons = {
  customers: Users,
  suppliers: Truck,
  expenses: Receipt,
  employees: Wallet,
  checks: FileCheck,
  reports: BarChart3,
};

export default function HomePage() {
  const { t, isAr } = useLanguage();
  const Arrow = isAr ? ArrowLeft : ArrowRight;
  const featureKeys = ['customers', 'suppliers', 'expenses', 'employees', 'checks', 'reports'];

  return (
    <>
      <section className="hero">
        <div className="hero-bg" aria-hidden="true" />
        <div className="container hero-grid">
          <div className="hero-copy">
            <div className="hero-brand">
              <img src="/haseela_h_logo.png" alt="" className="hero-mark" />
              <span className="hero-brand-text">
                <strong>{isAr ? t.brand : 'Haseela'}</strong>
                <small>{isAr ? 'Haseela' : 'حصيلة'}</small>
              </span>
            </div>
            <h1>{t.hero.title}</h1>
            <p>{t.hero.subtitle}</p>
          </div>
          <div className="hero-visual">
            <img
              src="/promo/phone-splash.png"
              alt={t.brand}
              className="hero-device"
            />
          </div>
          <div className="hero-actions">
            <Link to="/demo" className="btn btn-primary btn-lg">
              <span className="btn-label">
                {t.hero.cta}
                <Arrow size={18} />
              </span>
            </Link>
            <Link to="/features" className="btn btn-ghost btn-lg">
              {t.hero.secondary}
            </Link>
          </div>
        </div>
      </section>

      <section className="section" data-header-solid>
        <div className="container">
          <div className="section-head">
            <h2>{t.featuresPreview.title}</h2>
            <p>{t.featuresPreview.subtitle}</p>
          </div>
          <div className="feature-grid">
            {featureKeys.map((key) => {
              const Icon = featureIcons[key];
              const item = t.featureItems[key];
              return (
                <article key={key} className={`feature-tile tone-${key}`}>
                  <div className="feature-icon">
                    <Icon size={22} />
                  </div>
                  <h3>{item.title}</h3>
                  <p>{item.desc}</p>
                </article>
              );
            })}
          </div>
        </div>
      </section>

      <ShowcaseScroll />

      <section className="section">
        <div className="container">
          <div className="section-head">
            <h2>{t.how.title}</h2>
            <p>{t.how.subtitle}</p>
          </div>
          <div className="steps-grid">
            {[t.how.step1, t.how.step2, t.how.step3].map((step, i) => (
              <article key={step.title} className="step-card">
                <span className="step-num">{i + 1}</span>
                <h3>{step.title}</h3>
                <p>{step.desc}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="cta-banner">
            <Bell size={40} />
            <h2>{t.cta.title}</h2>
            <p>{t.cta.subtitle}</p>
            <Link to="/demo" className="btn btn-light btn-lg">
              {t.cta.button}
              <Arrow size={18} />
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
